import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Footer from '../components/Footer'
import './home.css'
import referralImage from '../assets/rewards.png'
import reward1Image from '../assets/rewards/reward1.jpg'
import reward2Image from '../assets/rewards/reward2.jpg'
import reward3Image from '../assets/rewards/reward3.jpg'
import rewardSmsImage from '../assets/rewards/reward_sms.jpg'
import rewardBannerImage from '../assets/rewards/reward_banner.jpg'
import mobile1Image from '../assets/rewards/mobile1.jpg'
import mobile2Image from '../assets/rewards/mobile2.jpg'
import mobile3Image from '../assets/rewards/mobile3.jpg'
import mobileSmsImage from '../assets/rewards/mobile_sms.jpg'

const Home = (props) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Account for navbar height when scrolling
        const navbarHeight = 70; // Same as var(--navbar-height)
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [location]); // Re-run effect if location changes

  return (
    <div className="home-container">
      <Helmet>
        <title>Susține @Romania</title>
        <meta property="og:title" content="Susține @Romania" />
      </Helmet>
      
      {/* Landing Section */}
      <section className="home-landing">
        <img
          alt="background"
          src="/external/map.svg"
          className="home-map"
        />
        <img
          alt="background"
          sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
          src="/external/compressed-7100w-5500w.gif"
          srcSet="/external/compressed-7100w-5500w.gif 1200w, /external/compressed-7100w-tablet.gif 800w, /external/compressed-7100w-mobile.gif 480w"
          className="home-gif"
        />
        <div className="home-hero">
          <div className="home-header">
            <h1 className="home-title">
              Transformă banii plătiți deja către stat într-o vacanță ✨
            </h1>
            <div className="home-tax-info">
              <div className="home-tax-badges">
                <div className="home-tax-badge">
                  <span className="home-tax-icon">💖</span>
                  <div className="home-tax-text">
                    <strong>Completează formularul</strong>
                    <span>Redirecționezi 3.5% din impozit</span>
                  </div>
                </div>
                <div className="home-tax-badge">
                  <span className="home-tax-icon">💪</span>
                  <div className="home-tax-text">
                    <strong>Nu te costă nimic</strong>
                    <span>Sunt bani plătiți deja către stat</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="home-cta" style={{ margin: '1rem 0' }}>
            <div className="home-info-tooltip">
              <span className="info-icon">ℹ️</span>
              <span>Apasă butonul albastru pentru o șansă să câștigi vacanța de mai jos. Apasă butonul verde dacă vrei să inviți prieteni și să câștigi o vacanță garantat.</span>
            </div>
            <div className="home-buttons-container">
              <Link to={`/formular230${window.location.search}`} className="home-button">
                <span>Ești angajat? Completează acum</span>
                <span>→</span>
              </Link>
              <a 
                href={process.env.REACT_APP_AUTH_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="home-button green-button"
              >
                <span>Inviți prieteni? Câștigă Garantat</span>
                <span>🎉</span>
              </a>
            </div>
          </div>
          
          <a href="https://www.annacharisma.com/" target="_blank" rel="noopener noreferrer" className="home-banner-link">
            <div className="home-banner">
              <img
                src={rewardBannerImage}
                alt="Luxury cabin in Transilvania"
                className="home-banner-image"
              />
              <div className="home-banner-content">
                <div className="home-prize-info">                
                  <p className="home-prize-subtitle">
                    Oricine completează Formularul 230 are o șansă să câștige această cabană de lux
                  </p>
                  <h2 className="home-prize-title">
                    Câștigă 7 nopți alături de 13 prieteni la Anna Charisma Chalet
                  </h2>
                  <ul className="home-prize-features">
                    <li className="home-reward-feature-pills">
                      <span className="home-reward-feature-pill pill-people">14 persoane</span>
                      <span className="home-reward-feature-pill pill-nights">7 nopți</span>
                    </li>
                    <li>Chalet de lux cu 8 dormitoare</li>
                    <li>Complet retras și liniștit în inima Văii Avrigului</li>
                    <li>Plajă privată amenajată lângă râu</li>
                    <li>Pivniță de vinuri și cigar lounge elegant</li>
                    <li>Ciubăr exterior cu apă fierbinte</li>
                    <li>Zonă outdoor de barbecue</li>
                    <li>Saună cu vedere spre natură</li>
                    <li>Foc de tabără pentru vibe-uri bune cu prietenii</li>
                    <li>Proiector exterior pentru cinema sub stele</li>
                    <li className="home-prize-value">Valoare totală: 9100 EUR</li>
                  </ul>
                </div>
              </div>
            </div>
          </a>

          <div className="home-steps">
            <div className="home-step">
              <span className="home-step-number">1</span>
              <p>Completează Formularul 230 în mai puțin de 3 minute</p>
            </div>
            <div className="home-step">
              <span className="home-step-number">2</span>
              <p>Intră automat în extragerea pentru 7 nopți la Anna Charisma Chalet</p>
            </div>
            <div className="home-step">
              <span className="home-step-number">3</span>
              <p>Fă-ți cont, invită prieteni și câștigă o vacanță garantat</p>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section id="info" className="home-info">
        <div className="home-info-content">
          <h2 className="home-info-title">
            De ce să redirecționezi 3.5% către @Romania?
          </h2>
          <p className="home-info-description">
            Impozitul pe venitul tău merge oricum la stat. Legea îți permite să decizi unde
            ajung 3.5% din acea sumă. Alege să susții @Romania și ai șansa să câștigi
            premii excepționale.
          </p>

          <div className="home-benefits">
            <div className="home-benefit-card">
              <span className="home-benefit-icon">💰</span>
              <h3>Nu te costă nimic</h3>
              <p>Suma pe care o redirecționezi este deja plătită ca impozit pe venit. Tu doar alegi unde să meargă.</p>
            </div>
            <div className="home-benefit-card">
              <span className="home-benefit-icon">🌱</span>
              <h3>Arată că iubești România</h3>
              <p>Fondurile strânse susțin proiecte care promovează România la nivel global.</p>
            </div>
            <div className="home-benefit-card">
              <span className="home-benefit-icon">🎁</span>
              <h3>Poți câștiga vacanțe</h3>
              <p>Inviți prieteni și primești o vacanță garantat. Altfel, completezi formularul și ai șansa să câștigi 7 nopți la Anna Charisma Chalet.</p>
            </div>
          </div>

          <div className="home-projects">
            <h3 className="home-projects-title">Care este impactul?</h3>
            <p className="home-projects-description">
              Cu fondurile strânse prin redirecționarea impozitului, ONG-ul nostru:
            </p>
            <ul className="home-projects-list">
              <li>Îmbunătățește imaginea turistică a României la nivel internațional</li>
              <li>Promovează patrimoniul natural, cultura și valorile României către milioane de oameni</li>
              <li>Generează peste 1 miliard de vizualizări prin conținut care promovează România, în fiecare an</li>
              <li>Ajunge la peste 100 de milioane de oameni în fiecare lună, care văd conținut autentic despre România</li>
              <li>Sprijină antreprenoriatul local și economia comunităților mici</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Rewards Section */}
      <section id="premii" className="home-rewards">
        <div className="home-rewards-content">
          <div className="home-rewards-header">
            <span className="home-rewards-label">Pregătește-te de vacanță</span>
            <h2 className="home-rewards-title">Strânge formulare completate și câștigă experiențe de neuitat</h2>
            <p className="home-rewards-description">
              Toți cei pe care îi inviți să completeze Formularul 230 pentru @Romania intră automat în tragerea
              la sorți pentru Anna Charisma Chalet. Dar tu poți câștiga și mai mult:
            </p>
          </div>

          <div className="home-rewards-grid">
            <a href="https://www.annacharisma.com/" target="_blank" rel="noopener noreferrer" className="home-reward-card-link">
              <div className="home-reward-card">
                <div className="home-reward-image-container">
                  <img
                    src={isMobile ? mobile1Image : reward1Image}
                    alt="Munții Bucegi"
                    className="home-reward-image"
                  />
                  <div className="home-reward-overlay">
                    <span className="home-reward-pill pill-purple">tombolă</span>
                    <span className="home-reward-pill pill-blue">1 formular</span>
                  </div>
                </div>
                <div className="home-reward-content">
                  <div className="home-reward-main">
                    <div className="home-reward-location">
                      <span className="home-reward-icon">📍</span>
                      <span>Valea Avrigului, Sibiu</span>
                    </div>
                    <h3 className="home-reward-title">Anna Charisma Chalet</h3>
                    <ul className="home-reward-features">
                      <li className="home-reward-feature-pills">
                        <span className="home-reward-feature-pill pill-people">14 persoane</span>
                        <span className="home-reward-feature-pill pill-nights">7 nopți</span>
                      </li>
                      <li>Chalet de lux cu 8 dormitoare</li>
                      <li>Complet retras și liniștit în inima Văii Avrigului</li>
                      <li>Plajă privată amenajată lângă râu</li>
                      <li>Pivniță de vinuri și cigar lounge elegant</li>
                      <li>Ciubăr exterior cu apă fierbinte</li>
                      <li>Zonă outdoor de barbecue</li>
                      <li>Saună cu vedere spre natură</li>
                      <li>Foc de tabără pentru vibe-uri bune cu prietenii</li>
                      <li>Proiector exterior pentru cinema sub stele</li>
                    </ul>
                  </div>
                  <div className="home-reward-info">
                    <div className="home-reward-info-header">
                      <span className="home-reward-info-icon">👥</span>
                      <span>Pentru tine și încă 13 prieteni</span>
                    </div>
                    <p className="home-reward-info-text">
                      Cu cât mai mulți prieteni din gașca ta completează formularul, cu atât aveți mai multe șanse ca unul dintre voi să câștige vacanța. Poți merge împreună cu până la 13 persoane!
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="https://stockestatemoieciu.ro/" target="_blank" rel="noopener noreferrer" className="home-reward-card-link">
              <div className="home-reward-card">
                <div className="home-reward-image-container">
                  <img
                    src={isMobile ? mobile2Image : reward2Image}
                    alt="Munții Apuseni"
                    className="home-reward-image"
                  />
                  <div className="home-reward-overlay">
                    <span className="home-reward-pill pill-purple">tombolă</span>
                    <span className="home-reward-pill pill-blue">10 formulare</span>
                  </div>
                </div>
                <div className="home-reward-content">
                  <div className="home-reward-main">
                    <div className="home-reward-location">
                      <span className="home-reward-icon">📍</span>
                      <span>Moieciu, Brașov</span>
                    </div>
                    <h3 className="home-reward-title">StockEstate Moieciu</h3>
                    <ul className="home-reward-features">
                      <li className="home-reward-feature-pills">
                        <span className="home-reward-feature-pill pill-people">14 persoane</span>
                        <span className="home-reward-feature-pill pill-nights">7 nopți</span>
                      </li>
                      <li>Chalet de poveste cu 7 dormitoare</li>
                      <li>Bucătărie chef-ready și living cu foc de lemne</li>
                      <li>Cinema privat pentru seri liniștite</li>
                      <li>Piscină încălzită în aer liber cu șezlonguri</li>
                      <li>Terasă cu grătar și priveliști montane</li>
                      <li>Servicii de catering artisanal direct la ușă</li>
                      <li>La doar câțiva pași de Castelul Bran</li>
                    </ul>
                  </div>
                  <div className="home-reward-info">
                    <div className="home-reward-info-header">
                      <span className="home-reward-info-icon">😏</span>
                      <span>Câștigi doar tu și împarți cu cine vrei</span>
                    </div>
                    <p className="home-reward-info-text">
                      După ce strângi 10 formulare completate, intri în tombola specială pentru această cabană de lux. Dacă o câștigi, poți să mergi împreună cu până la 13 prieteni!
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="https://thealtitude.ro/" target="_blank" rel="noopener noreferrer" className="home-reward-card-link">
              <div className="home-reward-card">
                <div className="home-reward-image-container">
                  <img
                    src={isMobile ? mobile3Image : reward3Image}
                    alt="Valea Prahovei"
                    className="home-reward-image"
                  />
                  <div className="home-reward-overlay">
                    <span className="home-reward-pill pill-green">garantat 🎉</span>
                    <span className="home-reward-pill pill-blue">100 formulare</span>
                  </div>
                </div>
                <div className="home-reward-content">
                  <div className="home-reward-main">
                    <div className="home-reward-location">
                      <span className="home-reward-icon">📍</span>
                      <span>Măguri, Cluj</span>
                    </div>
                    <h3 className="home-reward-title">The Altitude</h3>
                    <ul className="home-reward-features">
                      <li className="home-reward-feature-pills">
                        <span className="home-reward-feature-pill pill-people">2-4 persoane</span>
                        <span className="home-reward-feature-pill pill-nights">4 nopți</span>
                      </li>
                      <li>Vile private de 40–55 mp cu panoramă</li>
                      <li>Jacuzzi privat suspendat pe terasă</li>
                      <li>Terase panoramice peste văi incredibile</li>
                      <li>Design scandinav cu accente lemnoase</li>
                      <li>Piscină infinity cu vederi spre Munții Apuseni</li>
                      <li>Colț comun cu hamace pentru povești sub stele</li>
                      <li>Trasee secrete până la Cascada Vălul Miresei</li>
                      <li>Cine gourmet în aer liber cu produse locale</li>
                      <li>La o oră de oraș, departe de orice agitație</li>
                    </ul>
                  </div>
                  <div className="home-reward-info">
                    <div className="home-reward-info-header">
                      <span className="home-reward-info-icon">🏆</span>
                      <span>La 100 formulare strânse</span>
                    </div>
                    <p className="home-reward-info-text">                    
                      Pentru fiecare 100 de formulare strânse, primești o vacanță la The Altitude pentru 2-4 persoane sau una din alte 99 cabane de lux.
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </div>

          {/* CTA Button beneath reward cards */}
          <div className="home-affiliate-cta" style={{ margin: '2rem auto 0.5rem', textAlign: 'center' }}>
            <p className="home-affiliate-cta-text">
              Creează-ți cont pentru a începe să câștigi vacanțe:
            </p>
            <a
              href={process.env.REACT_APP_AUTH_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="home-affiliate-button"
            >
              Vreau vacanțe
              <span className="home-affiliate-arrow">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* SMS Donation Section */}
      <section id="sms" className="home-sms">
        <div className="home-sms-content">
          <div className="home-rewards-header">
            <span className="home-rewards-label">Donație prin SMS</span>
            <h2 className="home-rewards-title">
              Trimite SMS și poți câștiga o vacanță în fiecare lună!
            </h2>
            <p className="home-rewards-description">
              Fiecare SMS <strong className="home-highlight">reprezintă un pas înainte</strong> către a arăta lumii frumusețea țării noastre. 
              Cu doar 4€, susții eforturile noastre de a promova România pe plan global.
            </p>
          </div>
          
          <div className="home-sms-instructions">
            <div className="home-sms-steps">
              <div className="home-sms-step">
                <span className="home-step-number">1</span>
                <span className="home-step-text">Trimite un SMS cu textul <strong>ROMANIA</strong></span>
              </div>
              <div className="home-sms-step">
                <span className="home-step-number">2</span>
                <span className="home-step-text">La numărul <strong>8864</strong></span>
              </div>
              <div className="home-sms-step">
                <span className="home-step-number">3</span>
                <span className="home-step-text">Donezi <strong>4€</strong> pentru promovarea României</span>
              </div>
              <div className="home-sms-step">
                <span className="home-step-number">4</span>
                <span className="home-step-text">Ești înscris în tombola lunară de vacanțe!</span>
              </div>
            </div>
            
            <div className="home-sms-visual">
              <div className="home-sms-phone">
                <div className="home-phone-screen">
                  <div className="home-phone-header">
                    <span className="home-phone-cta">TRIMITE SMS</span>
                  </div>
                  <div className="home-message-bubble">
                    <span className="home-message-text">ROMANIA</span>
                    <span className="home-message-number">→ 8864</span>
                  </div>
                  <div className="home-phone-response">
                    <span>Mulțumim! Tocmai ai contribuit la promovarea României. ❤️🇷🇴</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="home-rewards-label home-sms-section-label">
            <span>Premiul din luna mai</span>
          </div>
          
          <div className="home-rewards-grid">
            <a href="https://www.luxgardenhotel.com/" target="_blank" rel="noopener noreferrer" className="home-reward-card-link">
              <div className="home-reward-card">
                <div className="home-reward-image-container">
                  <img
                    src={isMobile ? mobileSmsImage : rewardSmsImage}
                    alt="LuxGarden Hotel Azuga"
                    className="home-reward-image"
                  />
                  <div className="home-reward-overlay">
                    <span className="home-reward-pill pill-purple">tombolă</span>
                    <span className="home-reward-pill pill-blue">SMS</span>
                  </div>
                </div>
                <div className="home-reward-content">
                  <div className="home-reward-main">
                    <div className="home-reward-location">
                      <span className="home-reward-icon">📍</span>
                      <span>Azuga, Prahova</span>
                    </div>
                    <h3 className="home-reward-title">Lux Garden Hotel</h3>
                    <ul className="home-reward-features">
                      <li className="home-reward-feature-pills">
                        <span className="home-reward-feature-pill pill-people">2 persoane</span>
                        <span className="home-reward-feature-pill pill-nights">3 nopți</span>
                      </li>
                      <li>Oază de 5 stele la poalele Bucegilor</li>
                      <li>SPA premium: piscină interioară și saune luxoase</li>
                      <li>Fitness high‑end și terapii revitalizante</li>
                      <li>Restaurant gourmet cu panoramă montană</li>
                      <li>Terasa cu vedere spre Munții Bucegi</li>
                      <li>Suite cu espresso bar și smart entertainment</li>
                      <li>Circuit MTB și drumeții în pădurile Azugăi</li>
                    </ul>
                  </div>
                  <div className="home-reward-info">
                    <div className="home-reward-info-header">
                      <span className="home-reward-info-icon">🎁</span>
                      <span>Prin SMS, câștigi lunar</span>
                    </div>
                    <p className="home-reward-info-text">                    
                      În fiecare lună, un donator prin SMS este extras aleatoriu pentru a câștiga un sejur la unul dintre hotelurile noastre partenere. Premiul pentru luna aceasta: 3 nopți la Lux Garden Hotel Azuga.
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </div>
          
          <div className="home-sms-tagline">
            <span>Cu ajutorul tău, <span className="home-highlight">punem România</span> înapoi pe harta lumii. 🌍</span>
          </div>
        </div>
      </section>

      {/* Referral Section */}
      <section id="referral" className="home-referral">
        <div className="home-rewards-header">
          <span className="home-rewards-label">Fă-ți cont în aplicație</span>
          <h2 className="home-rewards-title">
            Convinge prieteni, familie sau cunoscuți să completeze Formularul 230
          </h2>
          <p className="home-rewards-description">
            Pentru fiecare persoană care completează Formularul 230 prin link-ul tău personal, crești șansele de câștig. La 100 de formulare strânse și validate de ANAF, primești garantat o vacanță. ANAF este singura instituție care poate valida formularele așa că îți recomandăm să strângi mai mult de 100 de formulare pentru a nu pierde șansa de a câștiga.
          </p>
        </div>
        <img
          src={referralImage}
          alt="Invită prieteni să completeze Formularul 230"
          className="home-referral-image"
        />
        <div className="home-affiliate">
          <div className="home-affiliate-content">
            <div className="home-affiliate-features">
              <div className="home-affiliate-feature">
                <span className="home-affiliate-icon">🎯</span>
                <div className="home-affiliate-text">
                  <strong>Obiectiv: 100 formulare</strong>
                  <span>Pentru o vacanță garantată</span>
                </div>
              </div>
              <div className="home-affiliate-feature">
                <span className="home-affiliate-icon">🔄</span>
                <div className="home-affiliate-text">
                  <strong>Tracking automat</strong>
                  <span>Vezi câte formulare ai strâns</span>
                </div>
              </div>
            </div>

            <div className="home-affiliate-cta">
              <p className="home-affiliate-cta-text">
                Creează-ți cont pentru a începe să strângi formulare:
              </p>
              <a
                href={process.env.REACT_APP_AUTH_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="home-affiliate-button"
              >
                Creează-ți cont acum
                <span className="home-affiliate-arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="home-faq">
        <div className="home-faq-content">
          <div className="home-faq-header">
            <span className="home-faq-label">Întrebări frecvente</span>
            <h2 className="home-faq-title">Ai întrebări? Noi avem răspunsuri</h2>
            <p className="home-faq-description">
              Află tot ce trebuie să știi despre procesul de redirecționare a 3.5% din impozitul pe venit și
              despre tombola noastră cu premii.
            </p>
          </div>

          <div className="home-faq-list">
            <details className="home-faq-item">
              <summary>Ce este formularul 230?</summary>
              <div className="home-faq-answer">
                <p>
                  Formularul 230 este documentul oficial de la ANAF prin care poți alege să redirecționezi 3.5% din impozitul
                  pe venit către o organizație non-profit precum @Romania. Acest formular nu implică niciun cost suplimentar
                  pentru tine - sunt banii pe care oricum îi plătești ca impozit la stat.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Cine poate completa formularul 230?</summary>
              <div className="home-faq-answer">
                <p>
                  Orice persoană care realizează venituri din salarii poate completa
                  acest formular.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Cum funcționează tombola de premii?</summary>
              <div className="home-faq-answer">
                <p>
                  Toți cei care completează Formularul 230 prin intermediul platformei noastre
                  intră automat în tragerea la sorți pentru premiul oferit. Poți câștiga premii și mai mari dacă îți creezi cont în platforma noastră și convingi alte persoane să completeze Formularul 230 pentru @Romania.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Care este data limită pentru depunerea Formularului 230?</summary>
              <div className="home-faq-answer">
                <p>
                  Formularul 230 poate fi depus până la data de 25 mai a anului în curs, pentru veniturile
                  realizate în anul precedent. Așa că, asigură-te că vei completa formularul înainte de această dată.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Cine depune Formularul 230 completat?</summary>
              <div className="home-faq-answer">
                <p>
                  După completarea formularului pe platforma noastră, noi ne ocupăm de depunerea acestuia
                  la ANAF. Nu trebuie să mergi personal la ANAF.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Asociația @Romania este non-profit?</summary>
              <div className="home-faq-answer">
                <p>
                  Da, Asociația @Romania este o organizație non-profit, neguvernamentală care, deși creează un impact semnificativ pentru România, nu beneficiază de bugete sau ajutor de la stat.
                </p>
              </div>
            </details>

            <details className="home-faq-item">
              <summary>Ce impact are susținerea ta?</summary>
              <div className="home-faq-answer">
                <p>
                  Susținerea ta ne ajută să continuăm să facem lucrul pe care îl facem cel mai bine: să promovăm România la nivel global, către milioane de oameni. Astfel, atragem un număr mai mare de turiști străini care își petrec vacanța în România și cheltuie bani în comerțul local.
                </p>
              </div>
            </details>
          </div>

          <div className="home-faq-footer">
            <p>Ai alte întrebări?</p>
            <a href="mailto:hi@romania.org.ro" className="home-faq-contact">Contactează-ne</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Home
